import angular from 'angular';
import Auth from '../../../../../../auth';

export default function FaultsViewEditDetailsDirective() {
  return {
    template: require('./details.html'),
    transclude: true,
    restrict: 'E',
    scope: {},
    controller: EditFaultConfigController,
    controllerAs: 'vm',
    bindToController: {}
  };

  function EditFaultConfigController($scope, gettextCatalog, faultsService, $uibModal, $stateParams, $location) {

    'ngInject';

    var vm = this;
    var configurationId = $stateParams.configurationId;

    vm.faults = [];
    vm.editFault = null;
    vm.copiedFault = null;
    vm.assets = [];
    vm.tabs = null;
    vm.loading = true;
    vm.isEditing = false;
    vm.editButtonClicked = null;
    vm.deleteButtonClicked = null;
    vm.configuration = {};
    vm.loading = true;
    vm.maxEmails = 10;
    vm.emailBackup = '';
    vm.nameBackup = '';
    vm.onLoadErrorFlag = false;
    vm.onLoadErrorText = '';

    //public methods
    vm.editButtonClicked = editButtonClicked;
    vm.deleteButtonClicked = deleteButtonClicked;
    vm.setTab = setTab;
    vm.isFormValid = isFormValid;

    function init() {
      if ($location.search().tab) {
        vm.tabs = $location.search().tab;
      } else {
        vm.tabs = 'faults';
      }
      getConfigurationById(configurationId).then(() => {
        //To let breadcrumbs directive know that the data for label has been loaded
        $scope.$emit('$viewContentLoaded');
      });
      //needed for the multi-email directivewhen tracking 'maxEmails"
      $scope.$on('totalEmails', (event, totalEmails) => {
        vm.maxEmails = totalEmails.length;
      });
    }
    init();

    function getConfigurationById(configurationId) {
      vm.loading = true;
      vm.configErrorText = null;

      return faultsService
        .getConfigById(configurationId)
        .then((configuration) => {
          if (configuration) {
            vm.configuration = configuration;
            vm.assets = configuration.equipment;
            vm.faults = configuration.triggers;
            vm.loading = false;
          } else {
            vm.onLoadErrorFlag = true;
            vm.onLoadErrorText = gettextCatalog.getString('Unable to retrieve the configuration');
            vm.loading = false;
          }
        })
        .catch(() => {
          vm.configErrorText = gettextCatalog.getString('An error occurred while updating the configuration');
        })
        .finally(() => {
          vm.loading = false;
          vm.isEditing = false;
        });
    }

    function copyConfigData() {
      var contacts = [];
      for (var i = 0; i < vm.configuration.contacts.length; i++) {
        contacts.push({
          email: vm.configuration.contacts[i]
        });
      }
      vm.nameBackup = angular.copy(vm.configuration.name);
      vm.emailBackup = angular.copy(contacts);
    }

    //Switch to edit mode
    function editButtonClicked() {
      copyConfigData();
      vm.isEditing = !vm.isEditing;
    }

    function deleteButtonClicked() {
      $uibModal.open({
        animation: true,
        template: require('../../delete-modal/delete.html'),
        controller: 'FaultsViewDeleteController',
        controllerAs: 'vm',
        resolve: {
          configurationId: () => {
            return configurationId;
          },
          configurationName: () => {
            return vm.configuration.name;
          }
        },
        size: 'md'
      });
    }

    function isFormValid(editFaultConfigForm) {
      editFaultConfigForm.$setSubmitted();
      if (editFaultConfigForm.$invalid) {
        vm.loading = false;
        return;
      } else {
        submitEditFaultConfigForm();
      }
    }

    $scope.faultConfigurationExists = function () {
      vm.duplicateConfigName = false;
      faultsService.getConfigByName(vm.nameBackup).then(function (response) {
        if ((response.data.name === vm.nameBackup) && (response.data.id != configurationId)) {
          vm.duplicateConfigName = true;
        }
      }).catch(err => {
        if (404 != err.status)
          console.log(err)
      });
    }

    function submitEditFaultConfigForm() {
      vm.loading = true;
      vm.configErrorText = null;
      vm.isEditing = false;

      const brand = Auth.getBrandClaim();

      faultsService
        .updateFaultConfig($stateParams.configurationId, vm.nameBackup, vm.emailBackup, brand)
        .then((configuration) => {
          vm.configuration.name = configuration.name;
          vm.configuration.contacts = configuration.contacts;
        })
        .catch(() => {
          vm.configErrorText = gettextCatalog.getString('An error occurred while updating the configuration');
        })
        .finally(() => {
          vm.loading = false;
          vm.isEditing = false;
        });
    }

    function setTab(selectedTab) {
      vm.tabs = selectedTab;
      $location.search('tab', selectedTab);
    }
  }
}